// src/components/PageTransition.js
import React, { useLayoutEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const variants = {
  initial: {
    opacity: 0,
    y: 0,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1,
      ease: 'easeOut',
    },
  },
  exit: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1,
      ease: 'easeIn',
    },
  },
};

const PageTransition = ({ children, locationKey }) => {
  // When the new page mounts, scroll to top before animation begins.
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [locationKey]);

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={locationKey}
        variants={variants}
        initial="initial"
        animate="animate"
        exit="exit"
        style={{ minHeight: '100vh' }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export default PageTransition;
